import { FormattedHTMLMessage, Link, useIntl } from 'gatsby-plugin-intl';
import React from 'react';
import Layout from '../../components/Layout';
import SEO from '../../components/SEO';
import { Desktop, Tablet } from '../../constants/responsive';
import { css } from '@emotion/core';
import Container from '../../components/Container';
import StoriesCarousel from '../../components/StoriesCarousel';
import { graphql, useStaticQuery } from 'gatsby';
import {
  BlogCard,
  BlogCardForMoreAboutInvesting,
} from '../../components/StoriesBlogCard';
import { useUpdateEffect, useWindowSize } from 'react-use';
import Blank from '../../components/Blank';

const StoriesButton = ({ value = 'Click', style, onClick = () => {} }) => {
  return (
    <div
      style={style}
      css={css`
        background-image: linear-gradient(107deg, #ee2f79 48%, #da1021);
        border-radius: 41px;
        text-align: center;
        width: fit-content;
        cursor: pointer;
        ${Tablet} {
        }
        ${Desktop} {
        }
      `}
      onClick={onClick}
    >
      <span
        css={css`
          color: #ffffff;
          font-weight: bold;
          font-size: 12px;
          line-height: 29px;
          padding: 0 16px;
          ${Tablet} {
            font-size: 12px;
            line-height: 29px;
            padding: 0 18px;
          }
          ${Desktop} {
            font-size: 16px;
            line-height: 37px;
            padding: 0 23px;
          }
        `}
      >
        {value}
      </span>
    </div>
  );
};

// first-video只有英文与中文视频，故繁简中文使用同一个视频
const localeToVideoLang = { 'zh-cn': 'cn', 'zh-hk': 'cn', en: 'en' };

const Stories = () => {
  const intl = useIntl();
  const data = useStaticQuery(graphql`
    query {
      videoPoster1: file(
        relativePath: { eq: "stories/video-posters/video1-poster.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      videoMobilePoster1: file(
        relativePath: { eq: "stories/video-posters/video1-mobile-poster.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 530) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      videoPoster2: file(
        relativePath: { eq: "stories/video-posters/video2-poster.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }

      allBlogPost {
        edges {
          node {
            id
            locale
            blog_id
            blog_url
            name
            title
            publish_date
            banner_image
            authors
            tags
            topics
          }
        }
      }
    }
  `);

  // first video在不同的宽度设备上显示不同版本的封面
  const { width: windowWidth } = useWindowSize();
  useUpdateEffect(() => {
    const poster = document.getElementsByClassName('video-poster')[0];
    const mobilePoster = document.getElementsByClassName('video-poster')[1];
    const video = document.getElementsByClassName('first-video-play')[0];
    const mobileVideo = document.getElementsByClassName(
      'first-video-mobile-play'
    )[0];
    if (windowWidth < 768) {
      poster.style.display = 'none';
      mobileVideo.currentTime === 0
        ? (mobilePoster.style.display = 'block')
        : (mobilePoster.style.display = 'none');
    } else {
      mobilePoster.style.display = 'none';
      video.currentTime === 0
        ? (poster.style.display = 'block')
        : (poster.style.display = 'none');
    }
  }, [windowWidth]);
  // 获得所有的【你我港钱】的blog文章
  const moneyTalksBlogPosts = data.allBlogPost.edges
    .map((node) => node.node)
    .filter((post) => post.locale === intl.locale)
    .filter((post) => {
      const tags = post.tags.map((tag) => tag.toLowerCase());
      return tags.includes('money_talks');
    })
    .sort((a, b) => {
      if (a.publish_date < b.publish_date) {
        return 1;
      }
      if (a.publish_date > b.publish_date) {
        return -1;
      }
      return 0;
    });
  return (
    <Layout footerForm>
      <SEO>
        title={intl.formatMessage({ id: 'stories.title' })}
        {/* description={intl.formatMessage({ id: "stories.description" })} */}
        {/* keywords={intl.formatMessage({ id: "stories.keywords" })} */}
      </SEO>
      {/* first video */}
      <div
        css={css`
          width: 100%;
          position: relative;
        `}
      >
        {/* first video end poster */}
        <img
          className='video-poster'
          css={css`
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: none;
            ${Tablet} {
              display: block;
            }
          `}
          src={data.videoPoster1.childImageSharp.fluid.src}
        ></img>
        <img
          className='video-poster'
          css={css`
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: none;
            ${Tablet} {
              display: none;
            }
          `}
          src={data.videoMobilePoster1.childImageSharp.fluid.src}
        ></img>
        <video
          className='first-video-play'
          css={css`
            width: 100%;
            display: none;
            ${Tablet} {
              display: block;
              // height: 723px;
            }
          `}
          src={`https://oss-static.aqumon.com/video/aqumon-home-v5/first-video-${
            localeToVideoLang[intl.locale]
          }.mp4`}
          autoPlay
          muted
          controls
          onEnded={() => {
            // 视频结束时显示封面
            document.getElementsByClassName(
              'first-video-play'
            )[0].currentTime = 0;
            document.getElementsByClassName('video-poster')[0].style.display =
              'block';
            console.log(
              document.getElementsByClassName('video-poster')[0].css,
              'css'
            );
          }}
          onPlay={() => {
            document.getElementsByClassName('video-poster')[0].style.display =
              'none';
          }}
          poster={data.videoPoster1.childImageSharp.fluid.src}
        />
        <video
          className='first-video-mobile-play'
          css={css`
            width: 100%;
            ${Tablet} {
              display: none;
            }
          `}
          src={`https://oss-static.aqumon.com/video/aqumon-home-v5/first-video-mobile-${
            localeToVideoLang[intl.locale]
          }.mp4`}
          muted
          controls
          onEnded={() => {
            // 视频结束时显示封面
            document.getElementsByClassName(
              'first-video-mobile-play'
            )[0].currentTime = 0;
            document.getElementsByClassName('video-poster')[1].style.display =
              'block';
          }}
          onPlay={() => {
            document.getElementsByClassName('video-poster')[1].style.display =
              'none';
          }}
          poster={data.videoMobilePoster1.childImageSharp.fluid.src}
        />
      </div>
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          background-image: linear-gradient(
            89deg,
            #ee2f79 15%,
            #e7245a 53%,
            #da1021 100%
          );
          //   text-align: center;
          padding: 28.5px 20px;
          height: 100%;
          margin-top: -5px;
          ${Tablet} {
            height: 125px;
            margin-top: 0px;
          }
          ${Desktop} {
            height: 147px;
          }
        `}
      >
        <h1
          css={css`
            margin-bottom: 0;
            color: #ffffff;
            font-size: 30px;
            ${Tablet} {
              font-size: 30px;
            }
            ${Desktop} {
              font-size: 48px;
            }
          `}
        >
          <FormattedHTMLMessage id={`stories.title`} />
        </h1>
      </div>
      <Blank height={[100, 100, 150]} />
      <Container
        css={css`
          ${Tablet} {
            padding: 0 60px;
          }
          ${Desktop} {
            padding: 0;
          }
        `}
      >
        <div
          css={css`
            ${Tablet} {
              text-align: center;
            }
            ${Desktop} {
            }
          `}
        >
          <p
            css={css`
              font-size: 16px;
              ${Tablet} {
                font-size: 16px;
              }
              ${Desktop} {
                font-size: 20px;
              }
            `}
          >
            <FormattedHTMLMessage id={`stories.campaign-description`} />
          </p>
          <div
            css={css`
              height: 50px;
              ${Desktop} {
                height: 75.2px;
              }
            `}
          ></div>
          <StoriesCarousel />
        </div>
      </Container>

      {/* second video */}
      <div
        css={css`
          width: 100%;
          position: relative;
          background-image: linear-gradient(
            89deg,
            #ee2f79 15%,
            #e7245a 53%,
            #da1021 100%
          );
          // height: 631px;
          height: 100%;
          margin-top: 150px;

          padding: 33px 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          ${Tablet} {
            margin-top: 100px;
            height: 487px;
            padding: 30px 0;
          }
          ${Desktop} {
            margin-top: 150px;
            height: 809px;
            padding: 74px 120px 67px;
          }
        `}
      >
        {/* <img
          className="video-poster"
          css={css`
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            padding: 33px 10px;
            object-fit: contain;
            ${Tablet} {
              padding: 30px 0;
            }
            ${Desktop} {
              padding: 74px 120px 67px;
            }
          `}
          src={data.videoPoster2.childImageSharp.fluid.src}
        ></img> */}
        <video
          className={`second-video-play`}
          css={css`
            width: 100%;
            height: 100%;
            display: none;
            ${Tablet} {
              display: block;
            }
            ${Desktop} {
            }
          `}
          src={`https://oss-static.aqumon.com/video/aqumon-home-v5/second-video1.mp4`}
          onEnded={() => {
            document.getElementsByClassName(
              'second-video-play'
            )[0].currentTime = 0;
            document.getElementsByClassName('second-video')[0].style.display =
              'flex';
            document.getElementsByClassName(
              'second-video-play'
            )[0].controls = false;
          }}
          muted
          poster={data.videoPoster2.childImageSharp.fluid.src}
        />
        <video
          className='second-video-mobile-play'
          css={css`
            // max-width: 400px;
            width: 100%;
            // height: 100%;
            ${Tablet} {
              display: none;
            }
          `}
          src={`https://oss-static.aqumon.com/video/aqumon-home-v5/second-video1.mp4`}
          onEnded={() => {
            document.getElementsByClassName(
              'second-video-mobile-play'
            )[0].currentTime = 0;
            document.getElementsByClassName('mobile-button')[0].style.display =
              'block';
            document.getElementsByClassName(
              'second-video-mobile-play'
            )[0].controls = false;
          }}
          muted
          poster={data.videoPoster2.childImageSharp.fluid.src}
        />
        <div
          className='second-video'
          css={css`
            display: flex;
            flex-direction: column;
            color: #ffffff;
            z-index: 1;
            top: 319px;
            padding: 30px 10px;
            text-align: left;
            max-width: 400px;
            align-self: flex-start;
            ${Tablet} {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              align-items: center;
              padding: 0;
              text-align: center;
            }
            ${Desktop} {
            }
          `}
        >
          <h2
            css={css`
              font-size: 30px;
              ${Tablet} {
                font-size: 30px;
              }
              ${Desktop} {
                font-size: 40px;
              }
            `}
          >
            <FormattedHTMLMessage id={`stories.BTS-video.from-the-producer`} />
          </h2>
          <p
            css={css`
              font-weight: 500;
              font-size: 16px;
              margin-bottom: 12px;
              max-width: 80%;
              ${Tablet} {
                font-size: 16px;
                max-width: 492px;
              }
              ${Desktop} {
                font-size: 20px;
                max-width: 618px;
              }
            `}
          >
            <FormattedHTMLMessage id={`stories.BTS-video.description`} />
          </p>

          {/* mobile button */}
          <div
            className='mobile-button'
            css={css`
              background-color: #ffffff;
              border-radius: 41px;
              text-align: center;
              width: fit-content;
              cursor: pointer;
              display: block;
              ${Tablet} {
                display: none;
              }
            `}
            onClick={() => {
              document.getElementsByClassName(
                'mobile-button'
              )[0].style.display = 'none';
              document
                .getElementsByClassName('second-video-mobile-play')[0]
                .play();
              document.getElementsByClassName(
                'second-video-mobile-play'
              )[0].controls = true;
            }}
          >
            <span
              css={css`
                color: #ee2f79;
                font-weight: bold;
                font-size: 12px;
                line-height: 29px;
                padding: 0 16px;
                ${Tablet} {
                  color: #ffffff;
                  font-size: 12px;
                  line-height: 29px;
                  padding: 0 18px;
                }
                ${Desktop} {
                  font-size: 16px;
                  line-height: 37px;
                  padding: 0 23px;
                }
              `}
            >
              {intl.formatMessage({ id: 'stories.BTS-video.button' })}
            </span>
          </div>
          {/* ipad & web button */}
          <div
            css={css`
              display: none;
              ${Tablet} {
                display: block;
              }
            `}
          >
            <StoriesButton
              value={intl.formatMessage({ id: 'stories.BTS-video.button' })}
              onClick={() => {
                document.getElementsByClassName(
                  'second-video'
                )[0].style.display = 'none';
                document.getElementsByClassName('second-video-play')[0].play();
                document.getElementsByClassName(
                  'second-video-play'
                )[0].controls = true;
              }}
            />
          </div>
        </div>
      </div>
      {/* 【你我港钱】blog文章 */}
      <div
        css={css`
          background: #f9f9f9;
          width: 100%;
          display: flex;
          justify-content: center;
          padding-bottom: 43.5px;
          ${Tablet} {
            padding-bottom: 100px;
          }
          ${Desktop} {
            padding-bottom: 150px;
          }
        `}
      >
        <Container
          css={css`
            padding: 0;
            display: flex;
            flex-direction: column;
            text-align: left;
            margin-top: 100px;
            padding: 0 20px;
            ${Tablet} {
              align-items: center;
              text-align: center;
              padding: 0 60px;
              margin-top: 52px;
            }
            ${Desktop} {
              padding: 0;
              margin-top: 136px;
            }
          `}
        >
          {/* Money Talks */}
          <h2
            css={css`
              font-size: 30px;
              ${Tablet} {
                font-size: 30px;
              }
              ${Desktop} {
                font-size: 40px;
              }
            `}
          >
            <FormattedHTMLMessage id={`stories.money-talks.title`} />
          </h2>
          <p
            css={css`
              font-size: 16px;
              ${Tablet} {
                font-size: 16px;
                padding: 0 78px;
              }
              ${Desktop} {
                font-size: 20px;
                padding: 0;
              }
            `}
          >
            <FormattedHTMLMessage id={`stories.money-talks.description`} />
          </p>
          <div
            css={css`
              display: flex;
              width: 100%;
              flex-wrap: wrap;
              justify-content: space-between;
              margin-top: 44.2px;
              margin-bottom: 30px;
            `}
          >
            {/* mobile */}
            <div
              css={css`
                flex-wrap: wrap;
                justify-content: space-between;
                display: flex;
                width: 100%;
                ${Tablet} {
                  display: none;
                }
              `}
            >
              {[1, 2, 3].map((value, index) => {
                return (
                  <BlogCard key={value} post={moneyTalksBlogPosts[index]} />
                );
              })}
            </div>
            {/* ipad */}
            <div
              css={css`
                flex-wrap: wrap;
                justify-content: space-between;
                display: none;
                ${Tablet} {
                  display: flex;
                }
                ${Desktop} {
                  display: none;
                }
              `}
            >
              {[1, 2, 3, 4].map((value, index) => {
                return (
                  <BlogCard key={value} post={moneyTalksBlogPosts[index]} />
                );
              })}
            </div>
            {/* Web */}
            <div
              css={css`
                display: none;
                flex-wrap: wrap;
                justify-content: space-between;
                ${Desktop} {
                  display: flex;
                }
              `}
            >
              {[1, 2, 3, 4, 5, 6].map((value, index) => {
                return (
                  <BlogCard key={value} post={moneyTalksBlogPosts[index]} />
                );
              })}
            </div>
          </div>
          <Link to='/learn/blog'>
            <StoriesButton
              value={intl.formatMessage({ id: 'stories.money-talks.button' })}
              style={{ alignSelf: 'center' }}
              onClick={() => {
                // 跳转到blog的指定tag
                sessionStorage['blog-selsected-tag'] = `"money_talks"`;
              }}
            />
          </Link>
        </Container>
      </div>
      {/* More About Investing */}
      <Container
        css={css`
          padding: 0;
          display: flex;
          flex-direction: column;
          text-align: left;
          margin-top: 38.5px;
          margin-bottom: 58px;
          padding: 0 20px;
          ${Tablet} {
            align-items: center;
            text-align: center;
            padding: 0 60px;
            margin-top: 102px;
            margin-bottom: 3px;
          }
          ${Desktop} {
            padding: 0;
            margin-top: 139px;
            margin-bottom: 100px;
          }
        `}
      >
        <h2
          css={css`
            margin-bottom: 0;
            font-size: 30px;
            ${Tablet} {
              font-size: 30px;
            }
            ${Desktop} {
              font-size: 40px;
            }
          `}
        >
          <FormattedHTMLMessage id={`stories.more-about-investing.title`} />
        </h2>
        <div
          css={css`
            width: 100%;
            margin-top: 26px;
            ${Tablet} {
              margin-top: 24px;
            }
            ${Desktop} {
              margin-top: 44px;
            }
          `}
        >
          {/* ipad */}
          <div
            css={css`
              flex-wrap: wrap;
              justify-content: space-between;
              display: none;
              ${Tablet} {
                display: flex;
              }
              ${Desktop} {
                display: none;
              }
            `}
          >
            {[1, 2].map((value) => {
              return (
                <BlogCardForMoreAboutInvesting
                  key={value}
                  blog={`stories.more-about-investing.blog-${value}`}
                />
              );
            })}
          </div>
          {/* mobile && Web */}
          <div
            css={css`
              display: none;
              flex-wrap: wrap;
              justify-content: space-between;
              display: flex;
              ${Tablet} {
                display: none;
              }
              ${Desktop} {
                display: flex;
              }
            `}
          >
            {[1, 2, 3].map((value) => {
              return (
                <BlogCardForMoreAboutInvesting
                  key={value}
                  blog={`stories.more-about-investing.blog-${value}`}
                />
              );
            })}
          </div>
        </div>
        <Link
          to={`/learn/how-we-invest`}
          css={css`
            :hover {
              color: black;
            }
            align-self: center;
            margin-top: 10px;
            ${Tablet} {
              margin-top: 15px;
            }
            ${Desktop} {
              margin-top: 18px;
            }
          `}
        >
          <StoriesButton
            value={intl.formatMessage({
              id: 'stories.more-about-investing.button',
            })}
          />
        </Link>
      </Container>
    </Layout>
  );
};

export default Stories;
